// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor{width:100%;position:relative;z-index:0;text-align:left}.text,.toolbar{border:1px solid #ccc}.w-e-text img{max-width:100%}.insertHouse{right:20px}.insertContent,.insertHouse{position:absolute!important;z-index:99999;cursor:pointer}.insertContent{right:110px}.houseUnit{border:1px solid #999;padding:10px}br{display:inline}.el-icon-office-building:before{font-size:30px;color:#409eff}.w-e-toolbar .w-e-menu{position:relative;text-align:center;padding:5px 10px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
